import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  private expenseAddedSource = new BehaviorSubject<boolean>(false);
  expenseAdded$ = this.expenseAddedSource.asObservable();

  private paymentAddedSource = new BehaviorSubject<boolean>(false);
  paymentAdded$ = this.paymentAddedSource.asObservable();

  announceExpenseAdded(): void {
    this.expenseAddedSource.next(true);
  }

  announcePaymentAdded(): void {
    this.paymentAddedSource.next(true);
  }

  // Vous pouvez ajouter d'autres sujets et méthodes au besoin
}
